import { getTradingOrderDetailsRoute } from '../containers/Routes/routes';
import { useCurrentAppLayoutId } from './useAppLayoutId';
import { useNavigateToOrderDetails } from './useNavigateToOrderDetails';

export function useNavigateToTradingOrderDetails() {
  const layoutId = useCurrentAppLayoutId();
  return useNavigateToOrderDetails(getTradingOrderDetailsRoute, layoutId);
}
